<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00041"><a class="calibre23" id="CHAPTER_V"></a>CHAPTER V.</h2>
<p class="center1"><strong class="calibre4">CHOOSING A CAREER.</strong></p>
<p class="calibre3">As Rod Blake, heavy-hearted, and weary, both mentally and physically from
his recent struggles, left his uncle’s house, he felt utterly reckless,
and paid no heed to the direction his footsteps were taking. His one idea
was to get away as quickly, and as far as possible, from those who had
treated him so cruelly. “If only the fellows had stood by me,” he thought,
“I might have stayed and fought it out. But to have them go back on me,
and take Snyder’s word in preference to mine, is too much.”</p>
<p class="calibre3">Had the poor boy but known that Billy Bliss was even then hastening to
bear a message of good-will and confidence in him from the “fellows” how
greatly his burden of trial would have been lightened. But he did not
know, and so he pushed blindly on, suffering as much from his own hasty
and ill-considered course of action, as from the more
<span id="pgepubid00042" title="[Pg 28]"></span> deliberate cruelty
of his adopted cousin. At length he came to the brow of a steep slope
leading down to the railroad, the very one of which Eltje’s father was
president. The railroad had always possessed a fascination for him, and he
had often sat on this bank watching the passing trains, wondering at their
speed, and speculating as to their destinations. He had frequently thought
he should like to lead the life of a railroad man, and had been pleased
when the fellows called him “Railroad Blake” on account of his initials.
Now, this idea presented itself to him again more strongly than ever.</p>
<p class="calibre3">An express train thundered by. The ruddy glow from the furnace door of its
locomotive, which was opened at that moment, revealed the engineman seated
in the cab, with one hand on the throttle lever, and peering steadily
ahead through the gathering gloom. What a glorious life he led! So full of
excitement and constant change. What a power he controlled. How easy it
was for him to fly from whatever was unpleasant or trying. As these
thoughts flashed through the boy’s mind, the red lights at the rear of the
train seemed to blink pleasantly at him, and invite him to follow them.</p>
<p class="calibre3"><span id="pgepubid00043" title="[Pg 29]"></span>“I will,” he cried,
springing to his feet. “I will follow wherever they
may lead me. Why should I not be a railroad man as well as another? They
have all been boys and all had to begin some time.”</p>
<p class="calibre3">At this moment he was startled by a sound of a voice close beside him
saying, “Supper is ready, Mister Rod.” It was Dan the stable boy; and, as
Rodman asked him, almost angrily, how he dared follow him without orders,
and what he was spying out his movements for, he replied humbly: “I ain’t
a-spying on you, Mister Rod, and I only followed you to tell you supper
was ready, ’cause I thought maybe you didn’t know it.”</p>
<p class="calibre3">“Well, I didn’t and it makes no difference whether I did or not,” said
Rod. “I have left my uncle’s house for good and all, Dan, and there are no
more suppers in it for me.”</p>
<p class="calibre3">“I was afeard so! I was afeard so, Mister Rod,” exclaimed the boy with a
real distress in his voice, “an’ to tell the truth that’s why I came after
you. I couldn’t a-bear to have you go without saying good-by, and I
thought maybe, perhaps, you’d let me go along with you. Please do, Mister
Rod. I’ll work for you and serve you faithfully, an’ I’d a heap
<span id="pgepubid00044" title="[Pg 30]"></span> rather go
on a tramp, or any place along with you, than stay here without you.
Please, Mister Rod.”</p>
<p class="calibre3">“No, Dan, it would be impossible to take you with me,” said Rodman, who
was deeply touched by this proof of his humble friend’s loyalty. “It will
be all I can do to find work for myself; but I’m grateful to you all the
same for showing that you still think well of me. It’s a great thing, I
can tell you, for a fellow in my position to know that he leaves even one
friend behind him when he is forced to go away from his only home.”</p>
<p class="calibre3">“You leaves a-plenty of them—a-plenty!” interrupted the stable boy
eagerly. “I heerd Miss Eltje telling her father that it was right down
cruel not to give you the cup, an’ that you couldn’t do a thing, such as
they said, any more than she could, or he could himself. An’ her father
said no more did he believe you could, an’ you’d come out of it all right
yet. Miss Eltje was right up an’ down mad about it, she was. Oh, I tell
you, Mister Rod, you’ve got a-plenty of friends; an’ if you’ll only stay
you’ll find ’em jest a-swarmin’.”</p>
<p class="calibre3">At this Rodman laughed outright, and said: “Dan, you are a fine fellow,
and you have done me good<span id="pgepubid00045" title="[Pg 31]"></span> already.
Now what I want you to do is just to
stay here and discover some more friends for me. I will manage to let you
know what I am doing; but you must not tell anybody a word about me, nor
where I am, nor anything. Now good-by, and mind, don’t say a word about
having seen me, unless Miss Eltje should happen to ask you. If she should,
you might say that I shall always remember her, and be grateful to her for
believing in me. Good-by.”</p>
<p class="calibre3">With this Rod plunged down the steep bank to the railroad track, and
disappeared in the darkness. He went in the direction of the next station
to Euston, about five miles away, as he did not wish to be recognized when
he made the attempt to secure a ride on some train to New York. It was to
be an attempt only; for he had not a cent of money in his pockets, and had
no idea of how he should obtain the coveted ride. In addition to being
penniless, he was hungry, and his hunger was increased tenfold by the
knowledge that he had no means of satisfying it. Still he was a boy with
unlimited confidence in himself. He always had fallen on his feet; and,
though this was the worse fix in which he had ever found himself, he had
faith that he would come out<span id="pgepubid00046" title="[Pg 32]"></span>
of it all right somehow. His heart was
already so much lighter since he had learned from Dan that some of his
friends, and especially Eltje Vanderveer, still believed in him, that his
situation did not seem half so desperate as it had an hour before.</p>
<p class="calibre3">Rod was already enough of a railroad man to know that, as he was going
east, he must walk on the west bound track. By so doing he would be able
to see trains bound west, while they were still at some distance from him,
and would be in no danger from those bound east and overtaking him.</p>
<p class="calibre3">When he was about half a mile from the little station, toward which he was
walking, he heard the long-drawn, far-away whistle of a locomotive. Was it
ahead of him or behind? On account of the bewildering echoes he could not
tell. To settle the question he kneeled down, and placed his ear against
one of rails of the west bound track. It was cold and silent. Then he
tried the east bound track in the same way. This rail seemed to tingle
with life, and a faint, humming sound came from it. It was a perfect
railroad telephone, and it informed the listener as plainly as words could
have told him, that a train was approaching from the west.</p>
<p class="calibre3"><span id="pgepubid00047" title="[Pg 33]"></span>
He stopped to note its approach. In a few minutes the rails of the east
bound track began to quiver with light from the powerful reflector in
front of its locomotive. Then they stretched away toward the oncoming
train in gleaming bands of indefinite length, while the dazzling light
seemed to cut a bright pathway between walls of solid blackness for the
use of the advancing monster. As the bewildering glare passed him, Rod saw
that the train was a long, heavy-laden freight, and that some of its cars
contained cattle. He stood motionless as it rushed past him, shaking the
solid earth with its ponderous weight, and he drew a decided breath of
relief at the sight of the blinking red eyes on the rear platform of its
caboose. How he wished he was in that caboose, riding comfortably toward
New York, instead of plodding wearily along on foot, with nothing but
uncertainties ahead of him.</p>
<p class="calibre3"><span id="pgepubid00048" title="[Pg 34]"></span></p>
<div class="pg-boilerplate" id="calibre_pb_20"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?33582290